module.exports = __webpack_public_path__ + "media/images/login-background-5420c396.png";